export default __webpack_public_path__ + "static/media/profileImg.dbe61922.svg";